/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types'
import React from 'react'
import {FormattedMessage} from 'react-intl'

import Link from '@salesforce/retail-react-app/app/components/link'
import {Button} from '@salesforce/retail-react-app/app/components/shared/ui'

import {colors} from '../../../constants'

const CartDrawerCta = ({onDrawerClose}) => {
    return (
        <Button
            as={Link}
            to="/checkout"
            onClick={onDrawerClose}
            width="100%"
            variant="outline"
            height="54px"
            px="14px"
            py="8px"
            maxW="279px"
            minw="207px"
            backgroundColor={colors.black}
            color={colors.white}
            borderRadius="102px"
            fontWeight="300"
            fontFamily="Roboto"
            fontSize="20px"
            _hover={{
                textDecoration: 'none'
            }}
            _focus={{
                backgroundColor: colors.black
            }}
        >
            <FormattedMessage
                defaultMessage="Checkout"
                id="cart_drawer_cta.link.checkout"
            />
        </Button>
    )
}

CartDrawerCta.propTypes = {
    onDrawerClose: PropTypes.func
}

export default CartDrawerCta
